import { Component } from '@angular/core';

@Component({
  selector: 'things-page',
  templateUrl: './things.component.html',
  styleUrls: ['./things.component.less']
})
export class ThingsPageComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/pages/things/things.component.ts